import type { AppTranslateFn } from "@/hooks/use-app-translation";

export const ACTIONS_COLUMN_HEADER_KEY = "common.table.columns.actions";

/** Row-actions column header; empty when the localization key is not loaded yet. */
export function getActionsColumnHeader(t: AppTranslateFn): string {
	const label = t(ACTIONS_COLUMN_HEADER_KEY);
	return label === ACTIONS_COLUMN_HEADER_KEY ? "" : label;
}
